"use client";

import Link from "next/link";
import { useLanguage } from "@/contexts/LanguageContext";
import { useState } from "react";

const Nav = () => {
    const { currentLang, setCurrentLang, translations } = useLanguage();
    const t = translations[currentLang];

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleLanguage = () => {
        setCurrentLang(currentLang === "KOR" ? "EN" : "KOR");
    };

    return (
        <header className="w-full h-24 px-4 md:px-12 flex gap-2 lg:gap-5 items-center bg-[rgba(255,255,255,0.95)] fixed top-0 left-0 z-50 backdrop-blur-md shadow-lg">
            <div className="text-2xl font-bold text-black">
                <Link href="/" className="text-black no-underline">
                    {t.logo}
                </Link>
            </div>

            <nav className="hidden md:block">
                <ul className="flex gap-2 lg:gap-5 font-bold">
                    <li>
                        <Link
                            href="/about"
                            className="text-black no-underline text-xl  transition-colors duration-300 hover:text-[#00c4ff]"
                        >
                            {t.menu[0]}
                        </Link>
                    </li>
                    <li>
                        <Link
                            href="/tech"
                            className="text-black no-underline text-xl  transition-colors duration-300 hover:text-[#00c4ff]"
                        >
                            {t.menu[1]}
                        </Link>
                    </li>
                    <li>
                        <button
                            onClick={() => alert("현재 청약기간이 아닙니다")}
                            // href="/stock"
                            className="text-[#00c4ff] no-underline text-xl transition-colors duration-300 hover:text-[#00c4ff]"
                        >
                            {t.menu[4]}
                        </button>
                    </li>
                    <li>
                        <Link
                            href="/notice"
                            className="text-black no-underline text-xl transition-colors duration-300 hover:text-[#00c4ff]"
                        >
                            {t.menu[5]}
                        </Link>
                    </li>
                </ul>
            </nav>

            {/* 모바일 메뉴 버튼 */}
            <div className="md:hidden absolute right-4">
                <button onClick={() => setIsMenuOpen((prev) => !prev)} className="text-black text-2xl">
                    ☰
                </button>
            </div>

            {isMenuOpen && (
                <div className="fixed size-full h-screen top-0 left-0 bg-[rgba(0,0,0,0.95)] z-50 block md:hidden">
                    <button
                        onClick={() => setIsMenuOpen((prev) => !prev)}
                        className="text-white text-2xl absolute top-4 right-4"
                    >
                        ×
                    </button>
                    <ul className="flex flex-col gap-4 size-full items-center justify-center">
                        <li>
                            <Link onClick={() => setIsMenuOpen(false)} href="/about" className="text-white text-2xl">
                                {t.menu[0]}
                            </Link>
                        </li>
                        <li>
                            <Link onClick={() => setIsMenuOpen(false)} href="/tech" className="text-white text-2xl">
                                {t.menu[1]}
                            </Link>
                        </li>
                        <li>
                            <button
                                onClick={() => {
                                    alert("현재 청약기간이 아닙니다");
                                    setIsMenuOpen(false);
                                }}
                                // href="/stock"
                                className="text-white text-2xl"
                            >
                                {t.menu[4]}
                            </button>
                        </li>
                        <li>
                            {" "}
                            <Link onClick={() => setIsMenuOpen(false)} href="/notice" className="text-white text-2xl">
                                {t.menu[5]}
                            </Link>
                        </li>
                    </ul>
                </div>
            )}

            <div className="absolute right-4 md:right-12 gap-5 hidden md:flex">
                <button className="text-black font-bold text-lg cursor-pointer" onClick={toggleLanguage}>
                    {currentLang}
                </button>
            </div>
        </header>
    );
};

export default Nav;
